import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
} from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const FILTER_SX = {
  minWidth: 140,
  '& .MuiInputBase-root': { height: 40, fontSize: 13, borderRadius: 1 },
  '& .MuiInputLabel-root': { fontSize: 13 },
};

const PROJECT_OPTIONS = [
  { value: '', label: 'All Projects' },
  { value: 'p1', label: 'Lodha Sterling' },
  { value: 'p2', label: 'Godrej Reserve' },
];

const STATUS_OPTIONS = [
  { value: '', label: 'All Status' },
  { value: 'available', label: 'Available' },
  { value: 'booked', label: 'Booked' },
  { value: 'hold', label: 'On Hold' },
  { value: 'sold', label: 'Sold' },
];

const CATEGORY_OPTIONS = [
  { value: '', label: 'All Categories' },
  { value: 'residential', label: 'Residential' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'plot', label: 'Plot' },
  { value: 'office', label: 'Office' },
  { value: 'retail', label: 'Retail' },
  { value: 'industrial', label: 'Industrial' },
];

const FACING_OPTIONS = [
  { value: '', label: 'Any Facing' },
  { value: 'north', label: 'North' },
  { value: 'south', label: 'South' },
  { value: 'east', label: 'East' },
  { value: 'west', label: 'West' },
  { value: 'ne', label: 'North-East' },
  { value: 'nw', label: 'North-West' },
  { value: 'se', label: 'South-East' },
  { value: 'sw', label: 'South-West' },
];

function InventoryFilters({ filters, onFilterChange }) {
  const { project, status, category, priceMin, priceMax, facing } = filters;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        rowGap: 1.5,
      }}
    >
      <FormControl size="small" sx={FILTER_SX}>
        <InputLabel id="filter-project">Project</InputLabel>
        <Select
          labelId="filter-project"
          label="Project"
          value={project || ''}
          onChange={(e) => onFilterChange('project', e.target.value)}
        >
          {PROJECT_OPTIONS.map((o) => (
            <MenuItem key={o.value || 'all'} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={FILTER_SX}>
        <InputLabel id="filter-status">Status</InputLabel>
        <Select
          labelId="filter-status"
          label="Status"
          value={status || ''}
          onChange={(e) => onFilterChange('status', e.target.value)}
        >
          {STATUS_OPTIONS.map((o) => (
            <MenuItem key={o.value || 'all'} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={FILTER_SX}>
        <InputLabel id="filter-category">Category</InputLabel>
        <Select
          labelId="filter-category"
          label="Category"
          value={category || ''}
          onChange={(e) => onFilterChange('category', e.target.value)}
        >
          {CATEGORY_OPTIONS.map((o) => (
            <MenuItem key={o.value || 'all'} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <TextField
          size="small"
          placeholder="Min"
          type="number"
          value={priceMin || ''}
          onChange={(e) => onFilterChange('priceMin', e.target.value)}
          sx={{ ...FILTER_SX, minWidth: 100 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ color: 'text.secondary' }}>
                <CurrencyRupeeIcon sx={{ fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          size="small"
          placeholder="Max"
          type="number"
          value={priceMax || ''}
          onChange={(e) => onFilterChange('priceMax', e.target.value)}
          sx={{ ...FILTER_SX, minWidth: 100 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ color: 'text.secondary' }}>
                <CurrencyRupeeIcon sx={{ fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <FormControl size="small" sx={FILTER_SX}>
        <InputLabel id="filter-facing">Facing</InputLabel>
        <Select
          labelId="filter-facing"
          label="Facing"
          value={facing || ''}
          onChange={(e) => onFilterChange('facing', e.target.value)}
        >
          {FACING_OPTIONS.map((o) => (
            <MenuItem key={o.value || 'any'} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default InventoryFilters;
